import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Container, Label, Form, FormFeedback, Input } from "reactstrap";
import * as url from "../../helpers/url_helper";
import { connect, useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import logoSm from "../../assets/images/logo.png";
import { PhoneInput } from 'react-international-phone';
const Login = props => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [login, setLogin]= useState("");
  const [password, setPassword]= useState("")
  const [errorMsg, setErrorMsg]= useState("")
  
  const signIn=()=> {
    fetch(url.BACKEND_URL+"/users/auth-root", {
      method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({login: login, password: password}) })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        localStorage.setItem("authUser", JSON.stringify(responseJson.data))
        history("/dashboard")
    } else { setErrorMsg(responseJson.message); }
    }) .catch((error) => { });
  };

  document.title = "Amavie | Page de connexion";
  return (
    <React.Fragment>
      {/* <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div> */}
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">
                      Bienvenue sur amavie !
                    </h5>
                    <p className="text-white-50">
                      Veuillez vous connecter svp
                    </p>
                    <Link to="/" className="logo logo-admin">
                      <img src={logoSm} height="44" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    <Form className="mt-4" action="#">

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="username">Login</Label>
                        <PhoneInput
                          defaultCountry="ci"
                          value={login}
                          onChange={setLogin}
                          inputStyle={{ width: "100%" }} 
                        />
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="userpassword">Mot de passe</Label>
                        <Input
                          name="password"
                          type="password"
                          className="form-control"
                          placeholder="Mot de passe"
                          onChange={(event)=> setPassword(event.target.value)}
                          value={password}
                        />
                      </div>

                      <div className="mb-3 row">
                        <div className="col-sm-6 text-start">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="button" onClick={()=>signIn()}>Se connecter</button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <strong style={{ color: "red" }}>{errorMsg}</strong>
                        </div>
                      </div>

                      <div className="mt-2 mb-0 row">
                        <div className="col-12 mt-4">
                          <Link to="/forgot-password"><i className="mdi mdi-lock"></i>Mot de passe oublié?</Link>
                        </div>
                      </div>

                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                {/* <p>
                  Don&#39;t have an account ?{" "}
                  <Link
                    to="/register"
                    className="fw-medium text-primary"
                  >
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p> */}
                <p>
                  © {new Date().getFullYear()} amavie. made by 
                  <a href="https://createdsarl.com" target='_blank'><i className="mdi mdi-lock"></i>CREATED SARL</a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);